/* eslint-disable react-hooks/exhaustive-deps */
import configs from "config";
import { useCallback, useMemo, useState } from "react";
import { useLocation } from "react-router";
import { when } from "utils";
import ls from "utils/secureStorage";

function useAccessKey() {
  const [rc, setRc] = useState(0);

  const location = useLocation();
  const queries = useMemo(() => new URLSearchParams(location?.search), [location]);

  const accessKey = useMemo(() => {
    const apiKey = when(queries.has("accessKey"), queries.get("accessKey")!, undefined);
    try {
      const accessDataStore = String(apiKey || ls.get(configs.ACCESS_KEY) || "");
      if (!accessDataStore) {
        return null;
      } else {
        ls.set(configs.ACCESS_KEY, accessDataStore);
      }
    } catch {
      return null;
    }
  }, [rc]);

  const setAccessKey = useCallback((accessKey: string) => {
    ls.set(configs.ACCESS_KEY, String(accessKey));
    refresh();
  }, []);

  const refresh = useCallback(() => {
    setRc((_rc) => _rc + 1);
  }, []);

  return { accessKey, setAccessKey, refresh };
}

export default useAccessKey;
